import { registerApi as api } from '../../api';

export const fetchSalaryAdvancesData = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/get_salary_advances/${current_month}`, {
      params: {
        client_id: client_ID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const updateSalaryAdvances = async (id, salaryAdvancesData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_salary_advances/${id}`, salaryAdvancesData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const deleteSalaryAdvances = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_salary_advances/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// Make sure your API function is set up correctly
export const salaryAdvancesUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_salary_advance', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};


export const multiDeleteSalaryAdvances = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_salary_advances', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
